// src/pages/ForgotPassword.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container" style={{ margin: "2rem auto", textAlign: "center" }}>
      <div className="logo-slot" style={{ marginBottom: "1rem" }}>
        <img src="/logo.png" alt="CardStoard Logo" style={{ width: "550px", height: "auto" }} />
      </div>

      <h2>Forgot Password</h2>

      {submitted ? (
        <div style={{ maxWidth: 320, margin: "0 auto" }}>
          <p style={{ color: "#2e7d32" }}>
            If that email is registered you will receive a reset link shortly.
          </p>
          <p style={{ marginTop: "1rem" }}>
            <Link to="/login">Back to Login</Link>
          </p>
        </div>
      ) : (
        <>
          <p style={{ color: "var(--text-muted)", marginBottom: "1rem", maxWidth: 320, margin: "0 auto 1rem" }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>
          <form
            onSubmit={handleSubmit}
            style={{ display: "flex", flexDirection: "column", gap: "1rem",
                     alignItems: "center", maxWidth: "320px", margin: "0 auto" }}
          >
            <input
              type="email"
              placeholder="Email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{ width: "100%", padding: "0.5rem" }}
            />
            <button
              type="submit"
              className="nav-btn"
              style={{ padding: "0.75rem", fontSize: "1rem", width: "100%" }}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
            {error && <p style={{ color: "red" }}>{error}</p>}
          </form>
          <p style={{ marginTop: "1rem" }}>
            <Link to="/login">Back to Login</Link>
          </p>
        </>
      )}
    </div>
  );
}
